import script from "./agentInstructions.vue?vue&type=script&setup=true&lang=js"
export * from "./agentInstructions.vue?vue&type=script&setup=true&lang=js"

import "./agentInstructions.vue?vue&type=style&index=0&id=694d63f4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-694d63f4"]])

export default __exports__